import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PermissionsService } from 'src/services/PermissionsService';
import { environment } from '../../../environments/environment';
import { DataService } from '../../../services/data.service';
import { RouterService } from '../../../services/router.service';
import { SecurityService } from '../../../services/security.service';
import { UserService } from '../../../services/user.service';
import { IdatatableResponse } from '../../Interfaces/idatatable';
import { IResponse } from '../../Interfaces/iresponse';
import { IuserEdit } from '../../Interfaces/iuser';
import { ErrorStateMatcher1 } from '../../error-state-matcher1';

@Component({
  selector: 'app-useredit',
  templateUrl: './useredit.component.html'
})

export class UsereditComponent implements OnInit {
  formUseredit: FormGroup;
  subRef$: Subscription;
  matcher = new ErrorStateMatcher1();
  message: string = "";
  useridname: string = "";

  constructor(
    private formBuilder: FormBuilder, 
    private dataService: DataService,
    private securityService: SecurityService,
    private routerparent: RouterService,
    private router: Router,
    private userservice: UserService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissionsService,
    private dialogRef : MatDialogRef<UsereditComponent>
  ) {
    this.formUseredit = formBuilder.group({
      //idtype: ['C'],
      //idnumber: ['', Validators.required],
      name: ['', Validators.required],
      lastname: ['', Validators.required],
      telefono1: ['', Validators.required],
      email1: ['', Validators.required],
      profile: ['A', Validators.required],
      userName: ['', [Validators.required, Validators.maxLength(20)]], /*Validators.minLength(1)],*/
      activo: [true] // new FormControl(false, [])
    });
  }
  selectedvalue: number; selectedview: string;
  idtypelist: IdatatableResponse[];
  profilelist: IdatatableResponse[];
  UserNameAvailable: boolean=false;

  ngOnInit() {
    this.message = "";
    this.idtypelist = [];
    let url = environment.urlAPI + 'api/datatable/';
    this.profilelist = [];
    this.permissionService.getPermission("USER").subscribe(_Result => {
      if (_Result.body.length > 0) {
        for (const entry of _Result.body) {
          if (entry.code == "U")
            this.UserNameAvailable = true;
        }
      }
    },
      (e) => {
        this.message = e.error;
        console.log(e);
      });
    this.dataService.get<IdatatableResponse[]>(url + "PROFL").subscribe(results => {
      if (results.ok) {
        for (const entry of results.body) {
          this.Addprofile({ id: entry.id, table: entry.table, code: entry.code, textvalue: entry.textvalue, numericvalue: entry.numericvalue, datevalue: entry.datevalue, boolvalue: entry.boolvalue });
        }
      }
    },
      (e) => {
        this.message = e.error;
        console.log(e);
      });
    //consultar el usuario
    this.userservice.Get(this.userservice.userID).subscribe(result => {
      if (result.ok) {
        this.useridname = result.body.idtypename;
        this.formUseredit.controls['name'].setValue(result.body.name);
        this.formUseredit.controls['lastname'].setValue(result.body.lastname);
        this.formUseredit.controls['telefono1'].setValue(result.body.tele1);
        this.formUseredit.controls['email1'].setValue(result.body.email1);
        this.formUseredit.controls['activo'].setValue(result.body.sysstatus == "A" ? true : false);
        this.formUseredit.controls['profile'].setValue(result.body.profile);
        this.formUseredit.controls['userName'].setValue(result.body.username);
      }
      else {alert("Error"); 
      }
    },
      (e) => {
        this.message = e.error;
        console.log(e);
      });
  }

  Addprofile(V_profile) {
    try {
      this.profilelist.push(V_profile);
    }
    catch (e) {
      console.log(e);
    }
  }

  Save()
  {
    try {
      const iuseredit: IuserEdit = {
        id:this.userservice.userID,
        name: this.formUseredit.value.name,
        lastname: this.formUseredit.value.lastname,
        telephone1: this.formUseredit.value.telefono1,
        email1: this.formUseredit.value.email1,
        profile: this.formUseredit.value.profile,
        sysstatus: this.formUseredit.value.activo ? "A" : "I",
        cc_id:0
      };
      const url = environment.urlAPI + 'api/user/'+this.userservice.userID.toString;
      this.dataService.put<IResponse>(url,iuseredit).subscribe(results => {
        if (results.ok) {
          this.openSB(results.body.response);
          this.dialogRef.close(true);
        }
        else { alert("Error"); }
      },
        (e) => {
          alert(e.error);
        }
      );
    }
    catch (e) {
      console.log(e.message);
      alert(e.message);
    }
  }

  Cancel()
  {
    this.dialogRef.close(false);
  }



  hasError(nombreControl: string, validacion: string) {
    const control = this.formUseredit.get(nombreControl);
    return control.hasError(validacion);
  }

  openSB(msg) {
    this._snackBar.open(msg,'', {
      duration: 5000, horizontalPosition: "center", verticalPosition: "top", panelClass: ['snackbarmsg']
    });
  }


}
